export enum ProjectRole {
  ADMIN = 'admin',
  USER = 'user',
}
